import { useFeature, FeatureResult } from "@growthbook/growthbook-react";
import { GrowthbookFeatures } from "components/growthbook/growthbook.types";

export type IJadwalChangesInfo = {
  heading: string;
  description: string;
  schedule: {
    old_start_time: string;
    old_end_time: string;
    start_time: string;
    end_time: string;
  }[];
  footer: string;
};

export const useJadwalChanges =
  (): FeatureResult<IJadwalChangesInfo | null> => {
    const result = useFeature<IJadwalChangesInfo>(
      GrowthbookFeatures.scheduleChangesInfo
    );

    return result;
  };
